import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as fromRoot from '@app/store/reducers';
import { AuthenticateUser } from '@core/auth2/store/auth2.actions';
import { Store } from '@ngrx/store';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as Sentry from '@sentry/angular-ivy';
import { InvalidInputExceptionInterceptor } from '@core/services/invalid-input-exception.interceptor';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(private store: Store<fromRoot.State>) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 && request.url.startsWith('/')) {
            this.store.dispatch(AuthenticateUser());
            return EMPTY;
          } else if (err.status === 401) {
            console.warn('Access denied by server');
            throw err;
          } else if (err.status === 403) {
            console.warn('Access denied by server');
            // pass this along as well
            // this.router.navigateByUrl('/app/unauthorized');
            throw err;
          } else if (err.status === 404) {
            // pass this along
            throw err;
          } else if (err.status === 500) {
            // silently pass this along
            throw err;
          } else if (err.status === 504) {
            // Gateway Timeout
            throw err;
          } else if (err.status === 400) {
            if (!InvalidInputExceptionInterceptor.isInvalidInputException(err))
              Sentry.captureException(err);

            throw err;
          } else {
            Sentry.captureException(err);
            throw err;
          }
        } else {
          Sentry.captureException(err);
          throw err;
        }
      }),
    );
  }
}
